/**
 * Converts integer cents back to a money amount.
 *
 * Pair this with `toCents` after cent-accurate arithmetic.
 *
 * @param cents Whole cents.
 * @returns The amount in major units.
 * @example
 * ```ts
 * fromCents(1001); // 10.01
 * fromCents(0); // 0
 * ```
 */
export function fromCents(cents: number): number {
  return cents / 100;
}
